import React from 'react';
import {
  Route,
  Redirect
} from "react-router-dom";

import { authenticationService } from 'auth/authenticationService.js'


// Auth Components
export default function PrivateRoute({ children, ...rest }) {
  authenticationService.getCurrentUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        authenticationService.isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}
